import React from 'react';
import {DoughnutChart} from '../../../components';
import {numberWithCommas} from '../../../Helpers/stringFormat';
import {Language} from '../../../context/LanguageContext';

export default function DataHasilCard({
  type = 1,
  rank,
  title,
  percentage,
  mtValue,
  mtHekValue,
  untungSemasa,
  blok,
}) {
  const {newObj, language} = Language();
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    aspectRatio: 1,
    width: '100%',
    plugins: {
      legend: {
        display: false, // set this to false to hide the legend
      },
    },
  };
  const handleRankWord = (rank) => {
    switch (rank) {
      case 1:
        return '1st';
      case 2:
        return '2nd';
      case 3:
        return '3rd';
      default:
        return `${rank}th`;
    }
  };

  const handleUntungSemasaColor = (untungSemasa) => {};

  const handleRenderUI = (type) => {
    switch (type) {
      case 2:
        return (
          <>
            <div className='dh_box'>
              <div className='dh_box_left'>
                <div className='rank'>{handleRankWord(rank)}</div>
                <div className='value'>
                  <p className='title'>{title}</p>
                  <div className='hasil'>
                    <div className='hasil_value'>
                      <p>
                        {numberWithCommas(mtValue.toFixed(2))} <span>MT</span>
                      </p>
                      /
                      <p>
                        {numberWithCommas(mtHekValue.toFixed(2))}{' '}
                        <span>MT/HEK</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='dh_box_right'>
                <DoughnutChart
                  data={{
                    labels: ['', ''],
                    datasets: [
                      {
                        label: '',
                        data:
                          percentage >= 100
                            ? [0, percentage]
                            : percentage === 0
                            ? [0, percentage]
                            : [100 - percentage, percentage],
                        backgroundColor: ['#E51D28', '#2B5180'],
                        hoverBackgroundColor: ['#E51D28', '#2B5180'],
                        borderColor: ['#E51D28', '#2B5180'],
                        borderWidth: 1,
                      },
                    ],
                  }}
                  options={options}
                />
              </div>
            </div>
          </>
        );
      case 1:
      default:
        return (
          <>
            <div className='dh_box'>
              <div className='dh_box_left'>
                <div className='rank'>{handleRankWord(rank)}</div>
                <div className='value'>
                  <p className='title'>{title}</p>
                  <div
                    className={`hasil ${untungSemasa < 0 ? 'red' : 'green'}`}
                  >
                    <p className='box'>Hasil</p>
                    <div className='hasil_value'>
                      <p>
                        {numberWithCommas(mtValue.toFixed(2))} <span>MT</span>
                      </p>
                      /
                      <p>
                        {numberWithCommas(mtHekValue.toFixed(2))}{' '}
                        <span>MT/HEK</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='dh_box_right'>
                <DoughnutChart
                  data={{
                    labels: ['', ''],
                    datasets: [
                      {
                        label: '',
                        data:
                          percentage >= 100
                            ? [0, percentage]
                            : percentage === 0
                            ? [0, percentage]
                            : [100 - percentage, percentage],
                        backgroundColor: ['#E51D28', '#2B5180'],
                        hoverBackgroundColor: ['#E51D28', '#2B5180'],
                        borderColor: ['#E51D28', '#2B5180'],
                        borderWidth: 1,
                      },
                    ],
                  }}
                  options={options}
                />
              </div>
            </div>
            <div
              className={`dh_untung_semasa ${
                untungSemasa < 0 ? 'red' : 'green'
              }`}
            >
              <p>Untung Semasa</p>
              <p>RM {numberWithCommas(untungSemasa.toFixed(2))}</p>
            </div>
          </>
        );
    }
  };

  return (
    <div className='dh_card'>
      <div className='dh_top'>{handleRenderUI(type)}</div>
      <hr />
      <div className='dh_bottom'>
        <p className='label'>{newObj.ProjectWord[language]}</p>
        <div className='value'>{blok}</div>
      </div>
    </div>
  );
}
